/**
 * Team WhatsApp alerts (ADR-039): the workspace's own WhatsApp number sends
 * its team quick updates and daily reports, to numbers the admin adds.
 * Shared by the API and the web; kept in sync with
 * apps/api/src/modules/team-alerts/team-alerts.schemas.ts.
 */
export const TEAM_INSTANT_ALERTS = [
    {
        key: 'NEW_LEAD',
        label: 'New lead',
        description: 'A lead comes in - website form, WhatsApp, website chat or added by hand.',
    },
    {
        key: 'APPOINTMENT',
        label: 'Appointments',
        description: 'An appointment is booked, rescheduled or cancelled.',
    },
    { key: 'ORDER', label: 'Orders', description: 'An order is placed or cancelled.' },
    {
        key: 'QUOTATION',
        label: 'Quotation requests',
        description: 'A customer asks for a quotation.',
    },
];
export const TEAM_DAILY_REPORTS = [
    {
        key: 'MORNING_SUMMARY',
        label: 'Morning summary',
        description: 'At your report time: follow-ups due and overdue, open and new leads, tasks, appointments, pending orders and unread chats.',
    },
    {
        key: 'OVERDUE_REMINDER',
        label: 'Overdue reminder',
        description: 'At your report time, only on days with overdue follow-ups or tasks.',
    },
    {
        key: 'DAY_RESULTS',
        label: 'End-of-day results',
        description: 'At 7 PM: new leads, leads won, appointments booked and orders placed today.',
    },
];
/** Most team numbers a workspace can add. */
export const TEAM_ALERT_MAX_RECIPIENTS = 10;
//# sourceMappingURL=team-alerts.js.map